import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.707 9.707a1 1 0 0 0-1.414-1.414L12 10.586 9.762 8.348a1.1 1.1 0 0 0-1.467-.053.91.91 0 0 0-.057 1.357L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.238 2.238c.39.39 1.046.413 1.467.053a.91.91 0 0 0 .057-1.357L13.414 12z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_cross-Ch2xRsjr.js.map
